import React from 'react';

export const FibaMsgContext = React.createContext([{show: true}, function(){}]);
